// extracted by mini-css-extract-plugin
export var alignCenter = "_9a-d";
export var bannerShown = "_9a-6";
export var buttonContent = "_9a-0";
export var cardList = "_9a-1";
export var centerContent = "_9a-2";
export var chevron = "_9a-3";
export var closePanelButton = "_9a-k";
export var conversationContextContainer = "_9a-l";
export var conversationDetailContainer = "_9a-4";
export var detailWrapper = "_9a-7";
export var dropdownButton = "_9a-e";
export var dropdownTitle = "_9a-9";
export var fullHeight = "_9a-5";
export var hidden = "_9a-a";
export var icon = "_9a-b";
export var mergeSuggestionWrapper = "_9a-m";
export var panel = "_9a-i";
export var portalButtonsWrapper = "_9a-c";
export var right = "_9a-j";
export var tableSummaryContainer = "_9a-8";
export var tableSummaryHeader = "_9a-g";
export var threeDotsButton = "_9a-f";
export var wide = "_9a-h";